import classcat from "classcat";
import React from "react";
import Drawer from "react-modern-drawer";

import { DRAWER_STYLES } from "@is/constants";
import { SearchFunctionProperties } from "@is/types";

import AttributePanel from "./AttributePanel";
import css from "./NewSearchDrawer.module.css";
import SearchBox from "./SearchBox";
import SearchHeader from "./SearchHeader";
import useManageNewSearchDrawer from "./hooks/useManageNewSearchDrawer";

type Props = {
  isOpen: boolean;
  onSearchDrawerHeightSet: (height: number) => void;
  innerRef?: React.RefObject<HTMLDivElement>;
  inDrawer?: boolean;
  handleSearch: ({
    newSearchTerms,
    pageNumber,
    sectionId,
  }: SearchFunctionProperties) => void;
};

const NewSearchDrawer = ({
  isOpen,
  innerRef,
  onSearchDrawerHeightSet,
  handleSearch,
  inDrawer = false,
}: Props) => {
  const {
    attributes,
    preferences,
    handlePreferenceClick,
    handlePriceRangeSearch,
    arePreferencesPending,
    filters,
    updatePreferences,
    currencyCode,
  } = useManageNewSearchDrawer(handleSearch);

  const SearchDrawerContent = (
    <div
      className={classcat([css.container, inDrawer && css.inDrawer])}
      ref={innerRef}
    >
      <SearchHeader />
      <SearchBox
        attributes={attributes}
        updatePreferences={updatePreferences}
        preferences={preferences}
        filters={filters}
        handleSearch={handleSearch}
      />
      <AttributePanel
        preferences={preferences}
        onPreferenceClick={handlePreferenceClick}
        onPriceRangeSearch={handlePriceRangeSearch}
        arePreferencesPending={arePreferencesPending}
        drawerRef={innerRef}
        onSearchDrawerHeightSet={onSearchDrawerHeightSet}
        currencyCode={currencyCode}
      />
    </div>
  );

  if (inDrawer) {
    return (
      <Drawer
        open={isOpen}
        direction="top"
        enableOverlay={false}
        // Start below the store-wide announcement banner when it is shown;
        // the custom property collapses to 0 when the banner is absent.
        style={{
          ...DRAWER_STYLES,
          top: "var(--announcement-banner-offset, 0)",
        }}
        size="auto"
      >
        {SearchDrawerContent}
      </Drawer>
    );
  } else {
    return SearchDrawerContent;
  }
};

export default NewSearchDrawer;
